module.exports = __webpack_public_path__ + "img/sponsor.48f50afb.jpg";